// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f5117e8e","494":"26eb9bdf","862":"cc9960e3"}[chunkId] + ".chunk.js";
};